/*------------------------------------------------------------------
Scroll Control Class
------------------------------------------------------------------*/

export default class ScrollControl {
  constructor() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    // The parent element
    this.parent = parent || window;
    // This will control the scrolling animations
    this.Controller = new TweenController();
    // The controller's active state
    this.active = false;
    // Initialise the Controller
    this.init();
  }
  init() {
    // Control the active states
    this.Controller.on('start', () => this.active = true);
    this.Controller.on('stop', () => this.active = false);
    this.Controller.on('end', () => this.active = false);

    // When we scroll the mouse wheel, we want to stop the tween!
    Meteora.attach(window, 'wheel touchstart', () => {
      if (this.active) this.stop();
    });
  }
  scrollTo() {
    let y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    // If we are already scrolling, stop the current tween
    this.stop();
    // Make sure y is a whole number
    y = Math.round(y);
    // Work out if we are trying to scroll further than the bottom of the page
    const to = y + window.innerHeight >= document.body.clientHeight ? document.body.clientHeight - window.innerHeight : y;
    if (this.parent === window) {
      // Tell the controller to scroll the window from it's current position to the new y position
      this.Controller.tween({
        from: window.scrollY,
        to: to
      }, value => window.scrollTo(0, value), duration);
    } else {
      // Tell the controller to scroll the parent from it's current position to the new y position
      this.Controller.tween({
        from: this.parent.scrollTop,
        to: to
      }, value => this.parent.scrollTop = value, duration);
    }
  }
  stop() {
    this.active = false;
    // Stop the controller
    this.Controller.stop();
  }
}